import {
	ApplicationBasis,
	DeadlineType,
	Degree,
	Gender,
	Race,
	ScholarshipFormat,
	StudyExperience,
	Presence,
	ScholarshipType,
} from '@studyportals/sp-scholarships-api-interface';

import { Country } from './country';
import { Discipline } from './discipline';
import { State } from './state';
import { UTCDateTime } from '@studyportals/mb-platform-date-time';

export class Scholarship {
	public constructor(
		public readonly id: string,
		public readonly sourceUrl: string,
		public readonly foundAtUrl: string | null,
		public readonly destinationCountries: readonly Country[],
		public readonly allDestinationCountries: boolean,
		public readonly destinationStates: readonly State[],
		public readonly allDestinationStates: boolean,
		public readonly originCountries: readonly Country[],
		public readonly allOriginCountries: boolean,
		public readonly originStates: readonly State[],
		public readonly allOriginStates: boolean,
		public readonly disciplines: readonly Discipline[],
		public readonly allDisciplines: boolean,
		public readonly grantDescription: string,
		public readonly grantAmount: number | null,
		public readonly grantCurrencyIso: string | null,
		public readonly deadlineType: DeadlineType,
		public readonly deadline: UTCDateTime | null,
		public readonly degrees: readonly Degree[],
		public readonly title: string,
		public readonly description: string,
		public readonly eligibility: string,
		public readonly benefits: string,
		public readonly applicationInfo: string | null,
		public readonly applicationFormUrl: string | null,
		public readonly providerOrganisationId: string | null,
		public readonly providerBodyId: string | null,
		public readonly minimumExperience: StudyExperience | null,
		public readonly isAwardedMultipleTimes: boolean,
		public readonly applicationBasis: readonly ApplicationBasis[],
		public readonly formats: readonly ScholarshipFormat[],
		public readonly types: readonly ScholarshipType[],
		public readonly ageMin: number | null,
		public readonly ageMax: number | null,
		public readonly gender: Gender | null,
		public readonly race: readonly Race[],
		public readonly timestampCreated: Date,
		public readonly timestampModified: Date,
		public readonly timestampModifiedByUser: Date,
		public readonly summary: string,
		public readonly presence: Presence
	) {}

	public get formattedDestinationCountries(): string {
		return this.destinationCountries.map((c) => c.name).join(',');
	}

	public get formattedProvider(): string {
		if (this.providerOrganisationId) {
			return `Organisation ${this.providerOrganisationId}`;
		}

		if (this.providerBodyId) {
			return `Body ${this.providerBodyId}`;
		}

		return '-';
	}

	public get formattedTimestampModified(): string {
		return this.timestampModifiedByUser.toISOString().substring(0, 19).replace('T', ' ');
	}
}
